import React, { FormEvent, useState, useContext } from 'react'
import { TextArea } from '@entur/form'
import { SecondaryButton } from '@entur/button'
import { colors, space } from '@entur/tokens'
import { GridContainer, GridItem } from '@entur/grid'
import { FetchState } from '../../api-clients/api-types'
import { useEmployeePatch } from '../../hooks/patch-employee'
import { DisabledContext } from '../../contexts/disable-context'
import { useEmployee } from '../../contexts/employee-context'

import { useClientInfo } from '../../contexts/client-info-context'
import { ReadOnlyContext } from '../../contexts/read-only-context'

export const CommentCard: React.FC = () => {
  const { hasSensitiveAccess } = useClientInfo()
  const { employee } = useEmployee()
  const { disabled } = useContext(DisabledContext)
  const { readOnly } = useContext(ReadOnlyContext)
  const [editNote, setEditNote] = useState(employee.sensitiveInfo?.note)
  const [patchStatus, patch] = useEmployeePatch()
  const isLoading = patchStatus === FetchState.LOADING
  const isDisabled = hasSensitiveAccess === false || isLoading || disabled || readOnly

  return (
    <div className={`comment-card ${disabled ? 'disabled' : ''}`}>
      {hasSensitiveAccess === true ? (
        <form
          style={{ display: 'flex', position: 'relative' }}
          onSubmit={(e: FormEvent) => {
            e.preventDefault()
            patch({}, { note: editNote })
          }}
        >
          <GridContainer spacing="small" style={{ marginTop: space.extraSmall }}>
            <GridItem small={12} medium={7}>
              <TextArea
                label="Skriv en kommentar..."
                onChange={(e: { target: { value: string } }) => setEditNote(e.target.value)}
                style={{ width: '100%', backgroundColor: 'white' }}
                value={editNote || ''}
                disabled={isDisabled}
              />
              <SecondaryButton
                className="search-form__search-button"
                type="submit"
                style={{
                  marginLeft: space.medium,
                  marginTop: space.extraSmall,
                  alignSelf: 'flex-end',
                }}
                loading={isLoading}
                disabled={isDisabled}
                data-cy="save-comment-button"
              >
                Lagre kommentar
              </SecondaryButton>
            </GridItem>
          </GridContainer>
        </form>
      ) : (
        <div
          style={{
            backgroundColor: colors.greys.grey90,
            padding: space.small,
            color: colors.blues.blue10,
            fontStyle: 'italic',
            marginBottom: space.medium,
            maxWidth: '600px',
          }}
        >
          Ikke tilgang
        </div>
      )}
    </div>
  )
}
